import { Divider, Grid, IconButton, Switch, Typography } from "@mui/material";
import React, { useState } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import WSSelectField from "../../Components/Select/WSSelect";
import { useForm } from "react-hook-form";
import { customValidation, validations } from "../../commonFunctions/CommonFunctions";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDateField from "../../Components/DateField/WSDateField";

export const CreditBalance: React.FC<any> = React.memo((props) => {
  const { control, register } = useForm();
    const [isCustomLimit, setIsCustomLimit] = useState(false);

  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsCustomLimit(event.target.checked);
  };


  return (
    <>
    <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
                  <WSTextField
                    label={"Opening Balance"}
                    {...register("openingBalance")}
                    id="openingBalance"
                    name="openingBalance"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
            <WSDateField
                    id="asOfDate"
                    name="asOfDate"
                    label={"As Of Date"}
                    dateFormat="DD-MM-YYYY"
                    denyFuturOrPast="custom"
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
      <Grid item xs={12}>
        <Typography variant="subtitle2" sx={{ fontWeight: 500 }}>
          Credit Limit
        </Typography>
      </Grid>

      
      <Grid item >
        <Typography
          variant="body2"
          sx={{
            color: !isCustomLimit ? 'primary.main' : 'text.secondary',
            fontWeight: !isCustomLimit ? 'bold' : 'normal',
          }}
        >
          No Limit
        </Typography>
      </Grid>

      {/* Switch */}
      <Grid item>
        <Switch
          checked={isCustomLimit}
          onChange={handleToggle}
          color="primary"
          size="small"
        />
      </Grid>

      {/* Custom Limit label */}
      <Grid item>
        <Typography
          variant="body2"
          sx={{
            color: isCustomLimit ? 'primary.main' : 'text.secondary',
            fontWeight: isCustomLimit ? 'bold' : 'normal',
          }}
        >
          Custom Limit
        </Typography>
      </Grid>
    </Grid>
    </>
  );
});
